export var schurDocs = {
  name: 'schur',
  category: 'Matrix',
  syntax: ['schur(A)'],
  description: 'Performs a real Schur decomposition of the real matrix A = UTU\'',
  examples: ['schur([[1, 0], [-4, 3]])', 'schur(A)'],
  seealso: ['lyap', 'sylvester']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/expression/embeddedDocs/function/matrix/schur.js
// module id = 1653
// module chunks = 2